/** Campo trampa: debe quedar vacío; los bots suelen rellenarlo. */
export const HONEYPOT_FIELD = '_hp_website';

export function honeypotFilled(data: FormData | Record<string, string>): boolean {
  const v =
    data instanceof FormData
      ? data.get(HONEYPOT_FIELD)
      : data[HONEYPOT_FIELD];
  return typeof v === 'string' && v.trim() !== '';
}
